module.exports = __webpack_public_path__ + "img/8.23b83c02.png";